import React from 'react';
import Contactform from './Contactform';
import { Container, Row, Col } from 'react-bootstrap';

const Contact = () => {
    return (
        <div className='contact'>
            <div className='max-width'>
                <Container>
                    <Row className='row1'>
                        <Col className='col1'>
                            <img src='contactimg.png' alt='' />
                        </Col>
                        <Col >
                            <Contactform /> 
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Contact;